export const file_upload = {
  label: 'Unggah file',
  button: 'Unggah',
  format: 'Format file',
  weight: 'Ukuran file maksimum seharusnya tidak melebihi 10mb.',
  drag: 'Tekan atau geser file ini untuk Unduh.',
  max_5000:
    'Berkas harus tanpa judul kolom, tanpa baris kosong, berisi angka dalam format internasional, tidak lebih dari 5000 baris.',
  file_example: 'Anda dapat menggunakan',
  download_example: 'Anda dapat mengunduh',
  template: 'templat.',
  invalid_format: 'Format file tidak valid',
  row_1000: 'File tidak boleh berisi lebih dari 1000 tugas, tidak termasuk header.',
  weight_mb: 'Ukuran file maksimum tidak boleh melebihi {weight}mb.',
  file_processing: 'Berkas sedang dimuat',
  file_fail: 'Kesalahan berkas'
};
